import {
  CONNECTED, SHUTDOWN, DISCONNECTED, ERROR,
  GAMES_SUMMARIES, ONLINE_COUNT,
} from '@/utils/constants/socket-events'

export default {
  [`SOCKET_${CONNECTED}`]({ commit, dispatch, getters }) {
    commit('setConnected', true)
    commit('setReconnectAttempt', 0)

    // reset shutting down
    if (getters.shuttingDown) {
      commit('setShuttingDown', false)
    }

    // first load
    if (!getters.loaded) {
      commit('setLoaded', true)
    }

    // resubscribe to namespaces
    const { namespaces } = getters
    commit('setNamespaces', [])

    Promise.allSettled(namespaces.map(ns => dispatch('subscribe', ns)))
  },
  [`SOCKET_${SHUTDOWN}`]({ commit, state }) {
    commit('setShuttingDown', true)
  },
  [`SOCKET_${DISCONNECTED}`]({ commit }, { event, wasOpen }) {
    commit('setConnected', false)
    commit('incReconnectAttempt')
  },
  [`SOCKET_${ERROR}`]({ commit }, error) {
    console.error(error)
  },
  [`SOCKET_${GAMES_SUMMARIES}`]({ commit }, summaries) {
    commit('setGamesSummaries', summaries)
  },
  [`SOCKET_${ONLINE_COUNT}`]({ commit }, count) {
    commit('setOnline', count)
  },
}
